/* eslint-disable max-len */
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../redux/reducers/rootReducer';
import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import { IOperationsPage } from '../../utils/types/state-types';
import MainHeader from '../MainHeader';
import MainHeroBlock from '../MainHeroBlock';
import classes from './operations-header.module.scss';

function OperationsHeader() {
  const operationsPage = useSelector<RootState, IOperationsPage | null>(
    (state) => state.mainReducer.operationsPage,
  );

  const isMobile = useMediaQuery(mediaQueries.mobile);

  const bgImage = useMemo(() => {
    if (isMobile) {
      return operationsPage?.startBlockMobileImage;
    }
    return operationsPage?.startBlockDesktopImage;
  }, [isMobile, operationsPage?.startBlockDesktopImage, operationsPage?.startBlockMobileImage]);

  return (
    <div className={classes.OperationsHeader}>
      <MainHeader />

      <MainHeroBlock bgImage={bgImage} />
    </div>
  );
}

export default memo(OperationsHeader);
